import { flatMap, groupBy } from 'lodash';
import { IntegrationField } from 'api/integrations';
import { sortObjectWithArray } from 'utils/sort-obj-with-array';

export const fullWidthItems = ['summary', 'description'];
export const defaultFieldsOrder = [...fullWidthItems, 'priority'];

export const getSortedJiraFields = (fields: IntegrationField[]) => {
  return flatMap(
    sortObjectWithArray(
      groupBy(fields, 'integrationFieldId'),
      defaultFieldsOrder,
    ),
  ) as IntegrationField[];
};
